const token_key = 'token_1.0.0';
const member_nick_name_key = 'member_nick_name_1.0.0';
const member_avatar_path_key = 'member_avatar_path_1.0.0';
const role_index_page = 'role_index_page_1.0.0';
const role_type = 'role_type_1.0.0';
const Role_code = 'Role_code_1.0.0';
const member_userId_key='urser_type_1.0.0'

function getToken() {
    let token = localStorage.getItem(token_key);

    if (token === null || typeof (token) === 'undefined') {
        return '';
    }

    return token;
}

function setToken(token) {
    localStorage.clear();

    localStorage.setItem(token_key, token);
}

function getRoleCode() {
    return localStorage.getItem(Role_code);
}

function setRoleCode(roleCode) {
    localStorage.setItem(Role_code, roleCode);
}
function getMemberNickName() {
    return localStorage.getItem(member_nick_name_key);
}

function setMemberNickName(memberNickName) {
    localStorage.setItem(member_nick_name_key, memberNickName);
}

function getMemberAvatarPath() {
    return localStorage.getItem(member_avatar_path_key);
}

function setUserId(userId) {
    localStorage.setItem(member_userId_key, userId);
}

function getUserId() {
    return localStorage.getItem(member_userId_key);
}

function setMemberAvatarPath(memberAvatarPath) {
    localStorage.setItem(member_avatar_path_key, memberAvatarPath);
}

function getRoleIndexPage() {
    return localStorage.getItem(role_index_page);
}

function setRoleIndexPage(roleIndexPage) {
    localStorage.setItem(role_index_page, roleIndexPage);
}

function setRoleType(roleType) {
    if(roleType==='ADMIN'){
        roleType ='AirWork楼宇总控后台'
    }else  if(roleType==='COMPANY'){
        roleType ='AirWork企业总控后台'
    }else {
        roleType ='AirWork总控后台'
    }

    localStorage.setItem(role_type, roleType);
}

function getRoleType() {
    let roleType =localStorage.getItem(role_type);
    if (roleType === null || typeof (roleType) === 'undefined') {
        return 'AirWork总控后台';
    }

    return roleType;
}

export default {
    getToken: getToken,
    setToken: setToken,
    getMemberNickName: getMemberNickName,
    setMemberNickName: setMemberNickName,
    getMemberAvatarPath: getMemberAvatarPath,
    setMemberAvatarPath: setMemberAvatarPath,
    getRoleIndexPage: getRoleIndexPage,
    setRoleIndexPage: setRoleIndexPage,
    setRoleType:setRoleType,
    getRoleType:getRoleType,
    getRoleCode:getRoleCode,
    setRoleCode:setRoleCode,
    setUserId:setUserId,
    getUserId:getUserId

};



// WEBPACK FOOTER //
// ./src/common/storage.js